import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IoMdRefresh } from "react-icons/io";
import { useContextProvider } from "../page-context/ContextProvider";
const RefreshButton = ({ label = "Refresh" }) => {
  const { t } = useTranslation();
  const { setRefresh } = useContextProvider();
  return (
    <Tooltip title={t(label)}>
      <span>
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            setRefresh((prev) => !prev);
          }}
          variant="Light Green">
          <IoMdRefresh />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default RefreshButton;
